// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"Tab_Tabs__r-3Wm","nav":"Tab_nav__2nL_g","active":"Tab_active__3BbnR"};